// extracted by mini-css-extract-plugin
export default {"componentWrapper":"GiphyComponent_componentWrapper__TnC30","listWrapper":"GiphyComponent_listWrapper__CkNyh"};